
import { JourneyLayout } from "@/components/journey/JourneyLayout";
import { VerseDisplay } from "@/components/journey/VerseDisplay";
import { strengthVerses } from "@/data/verses";

export default function JourneyStrength() {
  return (
    <JourneyLayout title="Strength">
      <VerseDisplay verses={strengthVerses} />
    </JourneyLayout>
  );
}
